import { render } from "./AuthorityManage.vue?vue&type=template&id=89329c36&scoped=true"
import script from "./AuthorityManage.vue?vue&type=script&lang=js"
export * from "./AuthorityManage.vue?vue&type=script&lang=js"

import "./AuthorityManage.vue?vue&type=style&index=0&id=89329c36&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89329c36"]])

export default __exports__